import { floor } from "~/tools/floor";
import { type FormatterUnit, formatUnits } from "~/tools/formatter-unit";
import { max as mathMax } from "~/tools/max";

export function* getTickValuesForDomain({
	min,
	max,
	tickCount,
}: {
	min: number;
	max: number;
	tickCount: number;
}): Generator<number> {
	const stepCount = mathMax(1, tickCount - 1);
	const step = (max - min) / stepCount;

	for (let index = 0; index < tickCount; index++) {
		yield min + step * index;
	}
}

export function hasDuplicateFormattedTicks({
	unit,
	min,
	max,
	tickCount,
	precision,
}: {
	unit: FormatterUnit;
	min: number;
	max: number;
	tickCount: number;
	precision: undefined | number;
}): boolean {
	const tickValues = getTickValuesForDomain({ min, max, tickCount });
	const formattedTicks = new Set<string>();

	for (const tickValue of tickValues) {
		const formattedTick = formatUnits(unit, tickValue, { precision });

		if (formattedTicks.has(formattedTick)) {
			return true;
		}

		formattedTicks.add(formattedTick);
	}

	return false;
}

export function getMinimumPrecisionForUniqueTickLabels({
	unit,
	min,
	max,
	tickCount,
	maxPrecision,
}: {
	unit: FormatterUnit;
	min: number;
	max: number;
	tickCount: number;
	maxPrecision: number;
}): undefined | number {
	let left = 0;
	let right = maxPrecision;
	let minimumPrecision: undefined | number;

	while (left <= right) {
		const precision = floor((left + right) / 2, 0);

		if (hasDuplicateFormattedTicks({ unit, min, max, tickCount, precision })) {
			left = precision + 1;
		} else {
			minimumPrecision = precision;
			right = precision - 1;
		}
	}

	return minimumPrecision;
}
